module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-familia-fc0be4f9744d37ec9d0763eb08eaf85b.svg";